import { GraphQLClient } from 'graphql-request';

import { graphqlEndpoint } from 'src/ui/constants/environment';

export const graphQLClient = new GraphQLClient(graphqlEndpoint);
